import { PostActivationKeyData } from 'additiv-services/types/services/clientService';
import { getClientServiceUrl, getClientServiceHeader } from '../../setup';
import Service from './service';
import { APIVersion, ServiceTypes } from '../../types/main';
import Security from './security';

class ClientService extends Service {
    static postContact(data: any) {
        return this.postRequest(`${getClientServiceUrl()}/contacts`, data, {
            isSecure: true, axiosSetup: { headers: getClientServiceHeader() },
        });
    }

    static getContact(contactId: number) {
        return this.getRequest(`${getClientServiceUrl()}/contacts/${contactId}/details`, {
            isSecure: true, axiosSetup: { headers: getClientServiceHeader() },
        });
    }

    static updateContact(contactId: number, data: any) {
        return this.putRequest(`${getClientServiceUrl()}/contacts/${contactId}/details`, data, {
            isSecure: true, axiosSetup: { headers: getClientServiceHeader() },
        });
    }

    static patchContact(contactId: number, data: any) {
        return this.patchRequest(`${getClientServiceUrl()}/contacts/${contactId}/details`, data, {
            isSecure: true, axiosSetup: { headers: getClientServiceHeader() },
        });
    }

    static postActivationKey(contactId: number, data: PostActivationKeyData) {
        return this.postRequest(`${getClientServiceUrl(APIVersion.V11)}/contacts/${contactId}/activationkey/send`, data, {
            isSecure: true, axiosSetup: { headers: getClientServiceHeader() },
        });
    }

    static async getSchema(key: string) {
        await Security.generateApplicationTokensIfNeeded(ServiceTypes.WITH_APP_TOKEN, true);

        return this.getRequest(`${getClientServiceUrl()}/schemas/${key}`, {
            axiosSetup: { headers: getClientServiceHeader() }, cache: false, isSecure: true, type: ServiceTypes.WITH_APP_TOKEN,
        });
    }

    static async getSchemaFields(key: string) {
        await Security.generateApplicationTokensIfNeeded(ServiceTypes.WITH_APP_TOKEN, true);

        return this.postRequest(`${getClientServiceUrl()}/schemas/${key}/input-metadata/search`, {
            axiosSetup: { headers: getClientServiceHeader() }, cache: false,
        });
    }

    static async getSchemasLists(language: string) {
        await Security.generateApplicationTokensIfNeeded(ServiceTypes.WITH_APP_TOKEN, true);

        return this.postRequest(`${getClientServiceUrl(APIVersion.V10)}/schemas/lists/search?language=${language}`, { listKeys: [] }, {
            axiosSetup: { headers: getClientServiceHeader() }, cache: false, isSecure: true, type: ServiceTypes.WITH_APP_TOKEN,
        });
    }

    static async getSchemaListByKey(key: string, language?: string) {
        await Security.generateApplicationTokensIfNeeded(ServiceTypes.WITH_APP_TOKEN, true);

        return this.postRequest(`${getClientServiceUrl(APIVersion.V10)}/schemas/lists/search?language=${language}`, { listKeys: [key] }, {
            axiosSetup: { headers: getClientServiceHeader() }, cache: false, isSecure: true, type: ServiceTypes.WITH_APP_TOKEN,
        });
    }
}

export default ClientService;
